<template>
  <!-- 長期不在一覧 -->
  <v-container>
    <v-card class="detail" flat>
      <!-- 2024.11.29 kouta.noborisaka 三井化学（市原工場）:絞り込みでEnterキー入力時にサブミット実行しないように「@submit.prevent」を追加 -->
      <v-form
        ref="tableForm"
        v-model="tableForm"
        lazy-validation
        @submit.prevent
      >
        <ryou-table
          ref="ryouTable"
          :rowKey="rowKey"
          :headers="headers"
          :url="url"
          :handleEdit="handleEdit"
          :handleDelete="handleDelete"
          :businessKeys="businessKeys"
          :queryParams="queryParam"
          :height="height"
          :needSearch="!ryoseiFlg"
        >
          <v-row slot="filterContainer">
            <v-col cols="6"></v-col>
            <v-col cols="2" class="addBtn">
              <ryou-blue-btn
                :label="'新規追加'"
                :handlerClick="handleAdd"
              ></ryou-blue-btn>
            </v-col>
          </v-row>
        </ryou-table>
      </v-form>
    </v-card>

    <p class="text-h5 ma-3">
      ※不在期間中に連絡先が変わる場合は、利用者情報の修正を行ってください。
    </p>
    
    <BuildingLongAbsenceDialog
      ref="modalForm"
      @ok="modalFormOk"
      :url="url"
      :building="building"
    ></BuildingLongAbsenceDialog>
  </v-container>
</template>

<script>
import RyouTable from "@/components/table/RyouTable.vue";
import RyouBlueBtn from "@/components/formInput/RyouBlueBtn.vue";

import BuildingLongAbsenceDialog from "./modules/BuildingLongAbsenceDialog.vue";
import { RyouTableMixins } from "@/mixins/RyouTableMixins";
export default {
  name: "BuildingLongAbsenceList",
  mixins: [RyouTableMixins],
  components: {
    RyouTable,
    RyouBlueBtn,
    BuildingLongAbsenceDialog,
  },
  data() {
    return {
      rowKey: "rowIndex",
      ryoseiFlg: true,
      tableForm: true,
      building: "",
      businessKeys: ["key_no"],
      headers: [
        // 2024.12.12 kouta.noborisaka 三井化学（市原工場）:ヘッダーの横幅を調整 Start
        {
          text: "ユーザID",
          class: "blue lighten-2 title",
          value: "user_id",
          align: "center",
          width: "10%",
          sortable: true,
          groupable: false,
        },
        {
          text: "物件名",
          class: "blue lighten-2 title",
          value: "building_name",
          align: "center",
          width: "8%",
          sortable: true,
          groupable: false,
        },
        {
          text: "部屋番号",
          class: "blue lighten-2 title",
          value: "room_id",
          align: "center",
          width: "9%",
          sortable: true,
          groupable: false,
        },
        {
          text: "ユーザ名",
          class: "blue lighten-2 title",
          value: "user_name",
          align: "center",
          width: "10%",
          sortable: true,
          groupable: false,
        },
        {
          text: "不在開始日",
          class: "blue lighten-2 title",
          value: "start_date",
          align: "center",
          width: "10%",
          sortable: true,
          groupable: false,
        },
        {
          text: "不在終了日",
          class: "blue lighten-2 title",
          value: "end_date",
          align: "center",
          width: "10%",
          sortable: true,
          groupable: false,
        },
        {
          text: "更新者",
          class: "blue lighten-2 title",
          value: "upd_user_name",
          align: "center",
          width: "10%",
          sortable: true,
          groupable: false,
        },
        {
          text: "更新日",
          class: "blue lighten-2 title",
          value: "upd_date",
          align: "center",
          width: "10%",
          sortable: true,
          groupable: false,
        },
        {
          text: "備考",
          class: "blue lighten-2 title",
          value: "remark",
          align: "center",
          width: "17%",
          sortable: true,
          groupable: false,
        },
        {
          text: "操作",
          class: "blue lighten-2 title",
          value: "actions",
          align: "center",
          width: "6%",
          sortable: false,
          groupable: false,
        },
        // 2024.12.12 kouta.noborisaka 三井化学（市原工場）:ヘッダーの横幅を調整 End
      ],
      url: {
        list:
          "/buildingLongAbsenceList/longAbsenceInfoGet" +
          "/" +
          this.$store.getters.getUserId +
          "/" +
          this.$store.getters.getUserClass,
        insert: "/buildingLongAbsenceList/longAbsenceInsert",
        update: "/buildingLongAbsenceList/longAbsenceUpdate",
        delete: "/buildingLongAbsenceList/longAbsenceDelete",
        getUserList:
          "/buildingLongAbsenceList/selectUserListGet" +
          "/" +
          this.$store.getters.getUserId +
          "/" +
          this.$store.getters.getUserClass,
      },
      height: 530,
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      if (this.$store.getters.getUserClass != 3) {
        this.ryoseiFlg = false;
      } else {
        this.ryoseiFlg = true;
      }
    },
  },
};
</script>

<style scoped>
.detail {
  padding-top: 20px;
}

.headerTitle {
  padding-bottom: 0px;
}

.buken {
  width: 100px;
  height: 40px;
  line-height: 40px;
}

.bukens {
  width: 300px;
  height: 80px;
}

.buken,
.bukens {
  float: left;
  box-sizing: border-box;
}

.headerGroup {
  padding-right: 0px;
}

.headerData {
  padding-left: 0px;
}
</style>
